export const BranchesRoutes = {
    GetBranches: "branch",
    GetBranch: "branch/GetBranch",
    DeleteBranch: "branch/delete",
    SaveBranch: "branch/save",
    CloneBranch: "branch/clone",
    ChangeBranchActivationState: "branch/ChangeBranchActivationState"
}